import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const printerMachinesStatusOptions = [
  { value: 'pending', label: 'Pendente' },
  { value: 'ready', label: 'Pronto' },
  { value: 'task_in_progress', label: 'Tarefa em andamento' },
  { value: 'failure', label: 'Falha' },
  { value: 'disabled', label: 'Desabilitado' },
  { value: 'offline', label: 'Offline' },
]

export const printerMachinesStrategy = optionsToStrategy(printerMachinesStatusOptions)
